const SIZE_CLASS_VALUES = {
  lg: "size-6",
  md: "size-5",
  sm: "size-4",
  xl: "size-8",
  xs: "size-3",
} as const;

export const SIZE_CLASS: Record<string, string> = SIZE_CLASS_VALUES;

// Numeric width/height in pixels — used by the React Native factory where
// Tailwind classes can't compose. Picked to match Tailwind's `size-N`
// classes: xs=3 (12px), sm=4 (16px), md=5 (20px), lg=6 (24px), xl=8 (32px).
export const SIZE_PIXELS: Record<string, number> = {
  lg: 24,
  md: 20,
  sm: 16,
  xl: 32,
  xs: 12,
};

// Lucide's native default in 24 viewBox units. Thickness scales with
// rendered size: 2 * (boxPx / 24).
export const DEFAULT_STROKE_WIDTH = 2;

export type IconSizeToken = keyof typeof SIZE_CLASS_VALUES;

export type IconSizePercentage = `${number}%`;

export type IconSize = IconSizeToken | number | IconSizePercentage;

export const DEFAULT_ICON_SIZE: IconSizeToken = "md";
